import { useState } from 'react';
import { useAuth } from '../../utils/AuthProvider';

interface IHeaderProps {
	showSideBar: () => void;
}
const Header = (props: IHeaderProps) => {
	const { account, logout } = useAuth();
	const { showSideBar } = props;
	const [userDropdown, setUserDropdown] = useState(false);

	return (
		<>
			<div className='nk-header nk-header-fixed is-light'>
				<div className='container-fluid'>
					<div className='nk-header-wrap'>
						<div className='nk-menu-trigger d-xl-none ms-n1'>
							<button type='button' className='nk-quick-nav-icon btn btn-round btn-icon fs-14px' onClick={() => showSideBar()}>
								<em className='icon ni ni-menu'></em>
							</button>
						</div>
						<div className='nk-header-tools'>
							<ul className='nk-quick-nav'>
								{account && (
									<>
										<li className='dropdown user-dropdown'>
											<button type='button' className='btn nav-link me-n1' onClick={() => setUserDropdown((prev) => !prev)}>
												<div className='user-toggle'>
													<div className='user-avatar sm'>
														{account.avatar ? (
															<></>
														) : (
															<>
																<em className='icon ni ni-user-alt'></em>
															</>
														)}
													</div>
													<div className='user-info d-none d-xl-block'>
														<div className='user-status align-left'>Xin chào</div>
														<div className='user-name dropdown-indicator align-left'>{account.firstName || account.fullName}</div>
													</div>
												</div>
											</button>
											<div className={`dropdown-menu dropdown-menu-md dropdown-menu-end ${userDropdown ? 'show' : ''}`}>
												<div className='dropdown-inner user-card-wrap bg-lighter d-none d-md-block'>
													<div className='user-card'>
														<div className='user-avatar'>
															{account.avatar ? (
																<></>
															) : (
																<>
																	<em className='icon ni ni-user-alt'></em>
																</>
															)}
														</div>
														<div className='user-info'>
															<span className='lead-text'>{account.fullName}</span>
															<span className='sub-text'>{account.username}</span>
														</div>
													</div>
												</div>
												<div className='dropdown-inner'>
													<ul className='link-list'>
														<li>
															<button
																type='button'
																// onClick={() => setChangePassword((prev) => !prev)}
																className='btn nav-link text-primary'
															>
																<em className='icon ni ni-unlock'></em>
																<span>Đổi mật khẩu</span>
															</button>
														</li>
													</ul>
												</div>
												<div className='dropdown-inner'>
													<ul className='link-list'>
														<li>
															<button type='button' onClick={() => logout()} className='btn nav-link text-danger'>
																<em className='icon ni ni-signout'></em>
																<span>Đăng xuất</span>
															</button>
														</li>
													</ul>
												</div>
											</div>
										</li>
									</>
								)}
							</ul>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Header;
